import React, { useState, useEffect } from 'react';
import styleSweet from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle';
import { FormControl, InputLabel, MenuItem, Select, Tooltip } from '@material-ui/core';
import { Edit, Visibility, RadioButtonChecked, Restore } from '@material-ui/icons';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ReactTable from 'components/ReactTable/ReactTable';
import { wsFindBy, wsUpdate } from 'services/WService';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Toasty, useToasty } from 'hooks/Toasty';
import Badge from 'components/Badge/Badge';
import { useModal } from 'hooks/useModal';
import { Link } from 'react-router-dom';
import Modal from './Modal';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Generado', accessor: 'generated', excelEnabled: false, width: 180 },
  { Header: 'Proveedor', accessor: 'CardName', width: 200 },
  { Header: 'Documento Sunat', accessor: 'Receipt', width: 160 },
  { Header: 'Fecha creación', accessor: 'created_at', width: 150 },
  { Header: 'Total', accessor: 'DocTotal', width: 150 },
  { Header: 'Fecha documento', accessor: 'tax_date', width: 150 },
  { Header: 'Fecha contabilización', accessor: 'DocDate', width: 150 },
  { Header: 'Fecha vencimiento', accessor: 'DocDueDate', width: 150 },
  { Header: 'TérminoPago', accessor: 'PymntGroup', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const useStyles = makeStyles(styleSweet);

function PurchaseDocumentList() {
  const classes = useStyles();
  const [documents, setDocuments] = useState([]);
  const [filters, setFilters] = useState({});
  const [notify, showNotify] = useToasty();
  const [model, setOpen] = useModal();
  const [alert, setAlert] = useState(null);
  const [dateType, setDateType] = useState('created_at');
  const [dataLoading, setDataLoading] = useState(false);

  async function getDocuments() {
    setDataLoading(true);
    if (Object.keys(filters).length === 0) return;
    const response = await wsFindBy('purch/purchase-document', { ...filters, date_type: dateType });
    setDataLoading(false);
    if (response.success === true) {
      setDocuments(response.data);
    }
  }

  function confirmDocument(purchaseId) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Está seguro de Procesar?"
        onConfirm={() => {
          wsUpdate('purch/purchase-document', purchaseId, {
            pch_sap_status: true,
          }).then(getDocuments);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />,
    );
  }

  async function restoreSapCount(purchase) {
    setDataLoading(true);
    let res = await wsUpdate(`purch/purchase-document/${purchase.id}/retry`);
    setDataLoading(false);
    if (res.success) {
      getDocuments();
    }
  }

  useEffect(() => {
    getDocuments();
  }, [filters]);

  return (
    <CardContainer /*title="Listado de factura de compras"*/ title={(<>Listado de factura de compras {dataLoading && <LoadingSpinner />}</>)}>
      {alert}
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={getDocuments} />

      <GridContainer>
        <GridItem xs={12} sm={2}>
          <FormControl fullWidth margin="normal">
            <InputLabel>Tipo Fecha</InputLabel>
            <Select
              value={dateType}
              onChange={(e) => {
                setDateType(e.target.value);
                setFilters((filters) => ({ ...filters }));
              }}
            >
              <MenuItem value="created_at">Fecha creación</MenuItem>
              <MenuItem value="tax_date">Fecha documento</MenuItem>
            </Select>
          </FormControl>
        </GridItem>
        <GridItem xs={12} sm={10}>
          <FilterCustom provider dateRange diffRange={3} getFilter={setFilters} />
        </GridItem>
      </GridContainer>

      <ReactTable
        columns={columns}
        formatDate="DD-MM-YYYY"
        defaultWidth={1600}
        data={documents.map((item, i) => {
          let genColor = 'danger';
          let generated = 'No';
          let tooltip = undefined;
          switch (item.proc_status) {
            case 'R':
              genColor = 'danger';
              generated = 'No';
              break;
            case 'Y':
              if (item.sapCount >= 3 && item.sapError !== null) {
                genColor = 'danger';
                generated = '¡Error!';
                tooltip = item.sapError;
                break;
              }
              genColor = 'warning';
              generated = 'Procesando...';
              break;
            case 'T':
              genColor = 'success';
              generated = 'Si';
              break;
            default:
              genColor = 'info';
              generated = item.proc_status;
              break;
          }

          return {
            num: (
              <div className="actions-right">
                {i + 1}
                <Link to={`/admin/compras/operaciones/importaciones/${item.id}`} target="_blank">
                  <Button justIcon round simple color="primary">
                    <Visibility />
                  </Button>
                </Link>

                <Tooltip title="Editar">
                  <Button
                    justIcon
                    round
                    simple
                    color="warning"
                    disabled={item.pch_sap_status}
                    onClick={() => {
                      if (item.pch_sap_status) return;
                      setOpen(item);
                    }}
                  >
                    <Edit />
                  </Button>
                </Tooltip>

                <Tooltip title="Procesar compra">
                  <Button
                    justIcon
                    round
                    simple
                    color="warning"
                    disabled={item.pch_sap_status}
                    onClick={() => {
                      confirmDocument(item.id);
                    }}
                  >
                    <RadioButtonChecked />
                  </Button>
                </Tooltip>
              </div>
            ),
            generated:
              tooltip !== undefined ? (
                <>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Tooltip title={tooltip}>
                      <div>
                        <Badge color={genColor}>{generated}</Badge>
                      </div>
                    </Tooltip>
                    <Button
                      color="warning"
                      round
                      justIcon
                      simple
                      onClick={() => {
                        restoreSapCount(item);
                      }}
                    >
                      <Restore />
                    </Button>
                  </div>
                </>
              ) : (
                <div className="actions-center">
                  <Badge color={genColor}>{generated}</Badge>
                </div>
              ),
            Receipt: `${item.ReceiptSerie}-${item.ReceiptNumber.padStart(8, '0')}`,
            ...item,
            tax_date: item.PchTaxDate || item.tax_date,
            DocDate: item.PchDocDate || item.DocDate,
            DocDueDate: item.PchDocDueDate || item.DocDueDate,
          };
        })}
      />
    </CardContainer>
  );
}

export default PurchaseDocumentList;
